export default __webpack_public_path__ + "static/media/cancel-glyph-red-16px .82101f5e.svg";